import React from "react";
import styles from "./AuthLayout.module.css";

type Props = {
  children: React.ReactNode;
  hideLeftOnMobile?: boolean;
};

export default function AuthLayout({ children, hideLeftOnMobile }: Props) {
  return (
    <main className={styles.page}>
      <div className={styles.shell}>
        {/* LEFT */}
        <section
          className={[
            styles.left,
            hideLeftOnMobile ? styles.leftHideOnMobile : "",
          ].join(" ")}
        >
          <div className={styles.divider} />

          <div className={styles.logoWrap}>
            <img src="/ridebase-logo.svg" alt="Ridebase" className={styles.logo} />
          </div>

          <h1 className={styles.headline}>
            Mobility
            <br />
            infrastructure,
            <br />
            reimagined.
          </h1>

          <img
            src="/entry-splash-graphic-1.svg"
            alt="Ridebase graphic"
            className={styles.graphic}
          />
        </section>

        {/* RIGHT */}
        <section className={styles.right}>
          <div className={styles.formCard}>{children}</div>
        </section>
      </div>
    </main>
  );
}
